import { styled, Box } from '../../base';

export const PageContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    width: '100%',
    backgroundColor: theme.palette.background.default,
}));

export const Header = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(3, 4),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    boxShadow: theme.shadows[2],
    position: 'relative',
}));

export const LogoImage = styled('img')(({ theme }) => ({
    height: '40px',
    width: 'auto',
    position: 'absolute',
    insetInlineStart: theme.spacing(4),
}));

export const HeaderContent = styled(Box)(() => ({
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

export const Content = styled(Box)(({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
    },
}));

export const PDFWrapper = styled(Box)(() => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
}));
